import { render, staticRenderFns } from "./positionEdit.vue?vue&type=template&id=7f8c6446&scoped=true&"
import script from "./positionEdit.vue?vue&type=script&lang=js&"
export * from "./positionEdit.vue?vue&type=script&lang=js&"
import style0 from "./positionEdit.vue?vue&type=style&index=0&id=7f8c6446&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8c6446",
  null
  
)

component.options.__file = "positionEdit.vue"
export default component.exports